<template>
  <div class="bg-card">
    <h3 class="text-center">
      {{ $t('pages.user-cv.sidebar.find-courses', 'Find courses') }}
    </h3>
    <Courses />
  </div>
</template>

<script>
import Courses from '@/components/jobs/infoSidebar/blocks/Courses';

export default {
  components: {
    Courses
  }
}
</script>
